import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { businessTypes } from '#client/constants';

import Display from './Display';

import { formatAddress, formatContact } from '../helpers/formatData';

const LLCFormation = ({
  type,
  title = 'Order Details',
  taskData: {
    name,
    alternates = [],
    domesticJurisdiction: jurisdiction,
    physicalAddress,
    mailingAddress,
    principalAddress,
    purpose,
    managerType,
    managers = [],
    members = [],
    registeredAgent: raWithEmail,
    contact,
    estimatedFormationDate: estFormDate,
  } = {},
  onClose,
}) => {
  const { formatMessage: fm } = useIntl();

  const ra = { ...raWithEmail, email: '' };

  const sections = [
    {
      title: fm({ id: 'orderView.items.businessName' }),
      filter: !!name,
      items: [{ content: name, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.estimatedFormationDate' }),
      filter: !!estFormDate,
      items: [{ content: estFormDate && format(parseISO(estFormDate), 'MMMM d, yyyy'), xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.alternateNames' }),
      filter: alternates !== null && alternates.length > 0,
      items:
        alternates &&
        alternates.map((alternate) => ({
          content: alternate,
          xs: 12,
        })),
    },
    {
      title: fm({ id: 'orderView.items.businessType' }),
      items: [{ content: businessTypes[type.split('_')[0]], xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.formationState' }),
      items: [{ content: jurisdiction, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.addresses' }),
      items: [
        {
          label: fm({ id: 'orderView.items.physicalAddress' }),
          content: physicalAddress ? formatAddress(physicalAddress, fm) : fm({ id: 'orderView.items.none' }),
          xs: 12,
          md: 6,
        },
        {
          label: fm({ id: 'orderView.items.mailingAddress' }),
          content: mailingAddress ? formatAddress(mailingAddress, fm) : fm({ id: 'orderView.items.none' }),
          xs: 12,
          md: 6,
        },
        {
          label: fm({ id: 'orderView.items.principalAddress' }),
          content: principalAddress ? formatAddress(principalAddress, fm) : fm({ id: 'orderView.items.none' }),
          xs: 12,
          md: 6,
        },
      ],
    },
    {
      title: fm({ id: 'orderView.items.businessPurpose' }),
      filter: !!purpose,
      items: [{ content: purpose, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.structure' }),
      filter: !!managerType,
      items: [{ content: managerType, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.managers' }),
      filter: managers !== null && managers.length > 0,
      items:
        managers &&
        managers.map((manager) => ({
          content: formatContact(manager, fm),
          xs: 12,
          md: 6,
        })),
    },
    {
      title: fm({ id: 'orderView.items.members' }),
      filter: members !== null && members.length > 0,
      items:
        members &&
        members.map((member) => ({
          content: formatContact(member, fm),
          xs: 12,
        })),
    },
    {
      title: fm({ id: 'orderView.items.registeredAgent' }),
      filter: !!raWithEmail,
      items: [{ content: formatContact(ra, fm), xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.primaryContact' }),
      filter: !!contact,
      items: [{ content: formatContact(contact, fm), xs: 12 }],
    },
  ];

  return <Display onClose={onClose} sections={sections} title={title} />;
};

LLCFormation.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string.isRequired,
  taskData: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LLCFormation;
